import React, { useState } from 'react';
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';
import FormWrapper from '../../../../Components/Form/FormWrapper';
import useTranslation from '../../../../Hooks/useTranslation';
import InputField from '../../../../Components/Form/components/InputField';
import SubmitButton from '../../../../Components/Button/SubmitButton';
// @ts-ignore
import styles from './AccountRemoveRequest.module.scss';
import Text from '../../../../Components/Base/Text/Text';
import { joinClasses } from '../../../../Utils/className.util';
import RemoveConfirmationModal from '../../../../Components/RemoveConfirmation/RemoveConfirmationModal';
import apiClient from '../../../../Services/ApiClient';
import useApiClient from '../../../Base/Hooks/useApiClient';
import ConfirmationModal from '../../../Base/Components/Confirmation/ConfirmationModal';
import AccountPagePanel from '../AccountPagePanel/AccountPagePanel';

interface Props {}

const AccountRemoveRequest: React.FC<Props> = ({}) => {
	const { t } = useTranslation();
	const { displayError, displaySuccess } = useApiClient();
	const [isRemoveConfirmationOpen, setIsRemoveConfirmationOpen] =
		useState(false);
	const [email, setEmail] = useState(null);
	const [isConfirmationOpen, setIsConfirmationOpen] = useState(false);

	const validationSchema = yup.object({
		email: yup
			.string()
			.email(t('validation.patientManualRegistrationLatamForm.email'))
			.required(t('validation.patientManualRegistrationLatamForm.email')),
	});

	const formMethods = useForm({
		defaultValues: {},
		resolver: yupResolver(validationSchema),
	});

	const handleSubmit = (values: any) => {
		if (values?.email) {
			setEmail(values.email);
		}
		setIsRemoveConfirmationOpen(true);
	};

	const handleRemoveAccount = async () => {
		try {
			const response = await apiClient.post(
				`/user/${email}/delete-request`,
				{},
			);
			if (response) {
				setIsConfirmationOpen(true);
			}
		} catch (e) {
			displayError(e);
		}
		setIsRemoveConfirmationOpen(false);
	};

	return (
		<AccountPagePanel
			title='component.accountRemoveRequest.title'
			text='component.accountRemoveRequest.text'>
			<>
				<div className={styles.formWrapper}>
					<FormWrapper formMethods={formMethods}>
						<InputField name='email' label='base.shared.email' isRequired />
						<SubmitButton
							onSubmit={handleSubmit}
							className={joinClasses(['btn btn-primary w-100', styles.button])}
							title='base.shared.remove2'
						/>
					</FormWrapper>
				</div>
				{isRemoveConfirmationOpen && (
					<RemoveConfirmationModal
						opened={isRemoveConfirmationOpen}
						onClose={() => setIsRemoveConfirmationOpen(false)}
						onConfirm={handleRemoveAccount}
						confirmationText='component.accountRemoveRequest.confirmationText'
						confirmationTitle='component.accountRemoveRequest.confirmationTitle'
					/>
				)}
				{isConfirmationOpen && (
					<ConfirmationModal
						imageSource='/dist/icons/v2/check-green.svg'
						title='component.accountRemoveRequest.confirmationModalTitle'
						text={
							t('component.accountRemoveRequest.confirmationModalText') ?? ''
						}
						isOpen={isConfirmationOpen}
						onClose={() => setIsConfirmationOpen(false)}
					/>
				)}
			</>
		</AccountPagePanel>
	);
};

export default AccountRemoveRequest;
